// HOT010 Ver3.0 勘定科目コードマッピング（一般商工業 業種コード10）
// 公式仕様: https://www.e-tax.nta.go.jp/hojin/gimuka/csv_jyoho4.htm
// 一般社団法人の正味財産系科目は「類似した勘定科目のコードを記録しても差し支えない」
// （公式仕様に明記）に基づき最近似コードで代替。

// --- BS ツリー構造 ---
// type:'T' = タイトル行, type:'1' = 金額行
// systemCodes: このHOT010行に集計するシステム科目コード配列
// totalCode/totalName: T行の合計行（直後に出力される type:'1' 合計行）

export const BS_ASSET_TREE = [
    { name: '資産の部', code: '10A000010', level: 2, type: 'T', children: [
        { name: '流動資産', code: '10A100010', level: 3, type: 'T',
          totalCode: '10A100800', totalName: '流動資産合計', children: [
            { name: '現金及び預金',          code: '10A100020', level: 4, type: '1', systemCodes: ['100','101','102','103','104','105','106','107','108'] },
            { name: '受取手形',              code: '10A100060', level: 4, type: '1', systemCodes: ['130','131'] },
            { name: '売掛金',                code: '10A100090', level: 4, type: '1', systemCodes: ['132','133'] },
            { name: '電子記録債権',          code: '10A100120', level: 4, type: '1', systemCodes: ['134'] },
            { name: '有価証券',              code: '10A100200', level: 4, type: '1', systemCodes: ['150'] },
            { name: '商品及び製品',          code: '10A100310', level: 4, type: '1', systemCodes: ['160','161','167'] },
            { name: '半製品',                code: '10A100350', level: 4, type: '1', systemCodes: ['162'] },
            { name: '仕掛品',                code: '10A100360', level: 4, type: '1', systemCodes: ['163'] },
            { name: '原材料及び貯蔵品',      code: '10A100390', level: 4, type: '1', systemCodes: ['164','165'] },
            { name: '前払金',                code: '10A100430', level: 4, type: '1', systemCodes: ['170'] },
            { name: '前払費用',              code: '10A100440', level: 4, type: '1', systemCodes: ['172'] },
            { name: '未収収益',              code: '10A100470', level: 4, type: '1', systemCodes: ['173'] },
            { name: '未収入金',              code: '10A100460', level: 4, type: '1', systemCodes: ['174'] },
            { name: '短期貸付金',            code: '10A100490', level: 4, type: '1', systemCodes: ['171'] },
            { name: '立替金',                code: '10A100500', level: 4, type: '1', systemCodes: ['176'] },
            { name: '仮払金',                code: '10A100510', level: 4, type: '1', systemCodes: ['177','178'] },
            { name: '仮払法人税等',          code: '10A100520', level: 4, type: '1', systemCodes: ['179'] },
            { name: '預け金',                code: '10A100530', level: 4, type: '1', systemCodes: ['175'] },
        ]},
        { name: '固定資産', code: '10A200010', level: 3, type: 'T',
          totalCode: '10A200800', totalName: '固定資産合計', children: [
            { name: '有形固定資産', code: '10A210010', level: 4, type: 'T',
              totalCode: '10A210800', totalName: '有形固定資産合計', children: [
                { name: '建物',              code: '10A210020', level: 5, type: '1', systemCodes: ['200'] },
                { name: '建物附属設備',      code: '10A210030', level: 5, type: '1', systemCodes: ['201'] },
                { name: '構築物',            code: '10A210040', level: 5, type: '1', systemCodes: ['202'] },
                { name: '機械及び装置',      code: '10A210070', level: 5, type: '1', systemCodes: ['203'] },
                { name: '車両運搬具',        code: '10A210110', level: 5, type: '1', systemCodes: ['204'] },
                { name: '工具、器具及び備品',code: '10A210120', level: 5, type: '1', systemCodes: ['205'] },
                { name: '土地',              code: '10A210130', level: 5, type: '1', systemCodes: ['206'] },
                { name: 'リース資産',        code: '10A210160', level: 5, type: '1', systemCodes: ['207'] },
                { name: '建設仮勘定',        code: '10A210170', level: 5, type: '1', systemCodes: ['208'] },
                { name: '減価償却累計額',    code: '10A210180', level: 5, type: '1', systemCodes: ['210'] },
                { name: '一括償却資産',      code: '10A210190', level: 5, type: '1', systemCodes: ['211'] },
            ]},
            { name: '無形固定資産', code: '10A220010', level: 4, type: 'T',
              totalCode: '10A220800', totalName: '無形固定資産合計', children: [
                { name: 'のれん',            code: '10A220020', level: 5, type: '1', systemCodes: ['225'] },
                { name: 'ソフトウェア',      code: '10A220050', level: 5, type: '1', systemCodes: ['224'] },
                { name: '工業所有権',        code: '10A220080', level: 5, type: '1', systemCodes: ['222'] },
                { name: '借地権',            code: '10A220100', level: 5, type: '1', systemCodes: ['223'] },
                { name: '電話加入権',        code: '10A220140', level: 5, type: '1', systemCodes: ['220'] },
                { name: '施設利用権',        code: '10A220150', level: 5, type: '1', systemCodes: ['221'] },
            ]},
            { name: '投資その他の資産', code: '10A230010', level: 4, type: 'T',
              totalCode: '10A230800', totalName: '投資その他の資産合計', children: [
                { name: '投資有価証券',      code: '10A230020', level: 5, type: '1', systemCodes: ['240'] },
                { name: '出資金',            code: '10A230040', level: 5, type: '1', systemCodes: ['241','242'] },
                { name: '長期貸付金',        code: '10A230180', level: 5, type: '1', systemCodes: ['244'] },
                { name: '破産更生債権等',    code: '10A230140', level: 5, type: '1', systemCodes: ['245'] },
                { name: '長期前払費用',      code: '10A230320', level: 5, type: '1', systemCodes: ['246'] },
                { name: '長期固定性預金',    code: '10A230330', level: 5, type: '1', systemCodes: ['247'] },
                { name: '差入保証金',        code: '10A230300', level: 5, type: '1', systemCodes: ['243','248'] },
                { name: '基本財産',          code: '10A230020', level: 5, type: '1', systemCodes: ['250'] }, // nonprofit: 投資有価証券コードで代替
                { name: '特定資産',          code: '10A230330', level: 5, type: '1', systemCodes: ['251'] }, // nonprofit: 長期固定性預金コードで代替
            ]},
        ]},
        { name: '繰延資産', code: '10A300010', level: 3, type: 'T',
          totalCode: '10A300800', totalName: '繰延資産合計', children: [
            { name: '開発費',                code: '10A300060', level: 4, type: '1', systemCodes: ['209'] },
        ]},
    ]},
];

export const BS_LIABILITY_TREE = [
    { name: '負債の部', code: '10B000010', level: 2, type: 'T', children: [
        { name: '流動負債', code: '10B100010', level: 3, type: 'T',
          totalCode: '10B100800', totalName: '流動負債合計', children: [
            { name: '支払手形',                              code: '10B100020', level: 4, type: '1', systemCodes: ['300'] },
            { name: '買掛金',                                code: '10B100040', level: 4, type: '1', systemCodes: ['301'] },
            { name: '電子記録債務',                          code: '10B100060', level: 4, type: '1', systemCodes: ['302'] },
            { name: '短期借入金',                            code: '10B100080', level: 4, type: '1', systemCodes: ['320','321'] },
            { name: '株主、役員又は従業員からの短期借入金',  code: '10B100920', level: 4, type: '1', systemCodes: ['303'] },
            { name: '未払金',                                code: '10B100130', level: 4, type: '1', systemCodes: ['310'] },
            { name: '未払費用',                              code: '10B100150', level: 4, type: '1', systemCodes: ['311'] },
            { name: '未払法人税等',                          code: '10B100160', level: 4, type: '1', systemCodes: ['308','309'] },
            { name: '前受金',                                code: '10B100180', level: 4, type: '1', systemCodes: ['312'] },
            { name: '前受収益',                              code: '10B100190', level: 4, type: '1', systemCodes: ['313'] },
            { name: '預り金',                                code: '10B100200', level: 4, type: '1', systemCodes: ['314'] },
            { name: '仮受金',                                code: '10B100210', level: 4, type: '1', systemCodes: ['315','316'] },
            { name: '賞与引当金',                            code: '10B100220', level: 4, type: '1', systemCodes: ['341'] },
        ]},
        { name: '固定負債', code: '10B200010', level: 3, type: 'T',
          totalCode: '10B200800', totalName: '固定負債合計', children: [
            { name: '社債',                code: '10B200020', level: 4, type: '1', systemCodes: ['332'] },
            { name: 'リース債務',          code: '10B200050', level: 4, type: '1', systemCodes: ['331'] },
            { name: '長期借入金',          code: '10B200060', level: 4, type: '1', systemCodes: ['330'] },
            { name: '退職給付引当金',      code: '10B200110', level: 4, type: '1', systemCodes: ['340'] },
            { name: '役員退職慰労引当金',  code: '10B200120', level: 4, type: '1', systemCodes: ['344'] },
            { name: '製品保証引当金',      code: '10B200130', level: 4, type: '1', systemCodes: ['342'] },
            { name: '貸倒引当金',          code: '10B200140', level: 4, type: '1', systemCodes: ['343'] },
        ]},
    ]},
];

// 純資産（株式会社・合同会社用）
// コードはe-Tax公式コード表（BScodeall_2019.xlsx 一般商工業）に準拠
export const BS_EQUITY_PROFIT = [
    { name: '純資産の部', code: '10C000010', level: 2, type: 'T', children: [
        { name: '株主資本', code: '10C100010', level: 3, type: 'T', children: [
            { name: '資本金',              code: '10C110010', level: 4, type: '1', systemCodes: ['400'] },
            { name: '資本剰余金',          code: '10C120010', level: 4, type: 'T', children: [
                { name: 'その他資本剰余金', code: '10C120030', level: 5, type: '1', systemCodes: ['401'] },
            ]},
            { name: '利益剰余金',          code: '10C130010', level: 4, type: 'T', children: [
                { name: '繰越利益剰余金',  code: '10C130370', level: 5, type: '1', systemCodes: ['402','403'] },
            ]},
            { name: '自己株式',            code: '10C100020', level: 4, type: '1', systemCodes: ['404'] },
        ]},
        { name: '評価・換算差額等', code: '10C200010', level: 3, type: 'T', children: [
            { name: 'その他有価証券評価差額金', code: '10C200020', level: 4, type: '1', systemCodes: ['405'] },
            { name: '繰延ヘッジ損益',           code: '10C200030', level: 4, type: '1', systemCodes: ['406'] },
        ]},
    ]},
];

// 正味財産（一般社団・財団法人用）- 公式仕様「類似コードで代替可」に基づく
// 10C130370=繰越利益剰余金, 10C200020=評価差額, 10C110010=資本金, 10C120030=その他資本剰余金
export const BS_EQUITY_NONPROFIT = [
    { name: '正味財産の部', code: '10C000010', level: 2, type: 'T', children: [
        { name: '一般正味財産',  code: '10C130370', level: 3, type: '1', systemCodes: ['420'] },
        { name: '指定正味財産',  code: '10C200020', level: 3, type: '1', systemCodes: ['421'] },
        { name: '基金',          code: '10C110010', level: 3, type: '1', systemCodes: ['422'] },
        { name: '代替基金',      code: '10C120030', level: 3, type: '1', systemCodes: ['423'] },
    ]},
];

// --- PL ツリー構造 ---
// 営業外収益に分類するシステム科目コード
export const NONOP_REVENUE_CODES = new Set(['607','608','609','610','612','613','614','615']);
// 営業外費用に分類するシステム科目コード
export const NONOP_EXPENSE_CODES = new Set(['671','672']);
// 仕入・原価に分類するシステム科目コード
export const COGS_CODES = new Set(['620','630','631','632','633','640']);

// PL科目コードマッピング（個別費用 → HOT010コード）
export const PL_EXPENSE_CODE_MAP = {
    '650': '10D100470', // 租税公課
    '651': '10D100470', // 荷造運賃手数料
    '652': '10D100470', // 運賃
    '653': '10D100470', // 水道光熱費
    '654': '10D100470', // 旅費交通費
    '655': '10D100470', // 通信費
    '656': '10D100470', // 広告宣伝費
    '657': '10D100470', // 接待交際費
    '658': '10D100470', // 保険料
    '659': '10D100470', // 修繕費
    '660': '10D100470', // 消耗品費
    '661': '10D100470', // 事務用品費
    '662': '10D100470', // 減価償却費
    '663': '10D100470', // 福利厚生費
    '664': '10D100470', // 法定福利費
    '665': '10D100470', // 給料手当
    '666': '10D100470', // 賞与
    '667': '10D100470', // 雑給
    '668': '10D100470', // 退職金
    '669': '10D100470', // 退職金掛金
    '670': '10D100470', // 外注費
    '673': '10D100470', // 地代家賃
    '674': '10D100470', // 貸倒損失
    '675': '10D100470', // 支払手数料
    '676': '10D100470', // 車両費
    '677': '10D100470', // 燃料費
    '678': '10D100470', // 賃借料
    '679': '10D100470', // リース料
    '680': '10D100470', // 採用教育費
    '681': '10D100470', // 会議費
    '682': '10D100470', // 新聞図書費
    '683': '10D100470', // 販売手数料
    '684': '10D100470', // 販売促進費
    '685': '10D100470', // その他
    '686': '10D100470',
    '687': '10D100470',
    '688': '10D100470',
    '689': '10D100470',
    '690': '10D100470',
    '691': '10D100470',
    '692': '10D100470',
    '693': '10D100470',
    '694': '10D100470',
    '695': '10D100470',
    '696': '10D100470',
    '697': '10D100470',
    '698': '10D100470',
    '699': '10D100470',
    '700': '10D100470', // 役員報酬
    '701': '10D100470', // 役員賞与
};

export const PL_NONOP_REVENUE_CODE_MAP = {
    '607': '10D200710', // 雑収入
    '608': '10D200010', // 受取利息
    '609': '10D200040', // 受取配当金
    '610': '10D200100', // 有価証券売却益
    '612': '10D200090', // 為替差益
    '613': '10D200640', // 償却債権取立益
    '614': '10D200570', // 固定資産売却益（営業外）
    '615': '10D200630', // 貸倒引当金戻入額
};

export const PL_NONOP_EXPENSE_CODE_MAP = {
    '671': '10D300260', // 支払利息
    '672': '10D300270', // 割引料（社債利息類似）
};
